import GlobalVar from '../utils/config'

const imagePath = (filename) => `${GlobalVar.BACKEND_URI}/files/${filename}`;

export default imagePath;
